import axios from "../http";

let module = "/classes/";


function getClassById(id){
    return axios.get(module+ id)
}

function getAllClass(data) {
    return axios.get(module+"allClass",data);
}

function getClassList(data) {
    return axios.post(module, data);
}

function updateClass(data) {
    return axios.post(module+data.id, data);
}

function updateClassStudents(classId,data) {
    return axios.post(module+"update/"+classId+"/students", data);
}

function updateSseatSetting(data){
    return axios.post(module+"seat-setting/",data)
}
function changeClassroom(data){
    return axios.put(module+"classRoom",data)
}
function graduate(id){
    return axios.post(module+"graduate/"+id);
}

function getLatelyClass() {
    return axios.get(module+"latelyClass");
}

export default {
    getAllClass,
    getClassList,
    updateClass,
    updateClassStudents,
    getClassById,
    updateSseatSetting,
    changeClassroom,
    graduate,
    getLatelyClass
}
